import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import Tag, { type TagColor } from '@/components/Tag/Tag'

import styles from './CurriculumLayoutHeader.module.scss'

const statusToLabelAndStatusMap = (
  tc: TFunction<'curriculumsManagement'>
): Record<string, { label: string; color: TagColor }> => ({
  active: {
    label: tc('label.active'),
    color: 'green'
  },
  draft: {
    label: tc('label.draft'),
    color: 'gray'
  }
})

type CurriculumLayoutHeaderProps = {
  title: string
  status: 'active' | 'draft'
}

const CurriculumLayoutHeader = (props: CurriculumLayoutHeaderProps) => {
  const { t: tc } = useTranslation('curriculumsManagement')

  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{props.title}</h1>
      <Tag {...statusToLabelAndStatusMap(tc)[props.status]} variant="on-blue" />
    </div>
  )
}

export default CurriculumLayoutHeader
